import { render, staticRenderFns } from "./ElemTable.vue?vue&type=template&id=14d837c0&"
import script from "./ElemTable.vue?vue&type=script&lang=js&"
export * from "./ElemTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports